<template>
	<v-dialog v-model="dialog" max-width="800px" persistent>
		<v-card>
			<s-toolbar label="RESUMEN POR SEMANA" dark color="#8e8f91" excel @excel="downloadExcel"></s-toolbar>
			<v-card-text>
				<v-col style="padding-top:0px;">
					<v-row justify="center">
						<v-col lg="3" style="padding-bottom:0px">
							<s-select label="Año" :items="years" outlined hide-details dense
								v-model="year"></s-select>
						</v-col>
						<v-col lg="3" style="padding-bottom:0px">
							<s-select small-chips attach="" label="N° Semana" dense hide-details outlined
								:items="itemsWeek" v-model="week"></s-select>
						</v-col>
						<v-col lg="3">
							<s-date label="Fecha Inicio" v-model="BeginDate" />
                        </v-col>
						<v-col lg="3">
							<s-date label="Fecha Fin" v-model="EndDate" />
                        </v-col>
					</v-row>
				</v-col>
				<!-- Fila de cabecera adicional -->
				<v-row>
					<v-col v-for="(item, index) in headerRow" :key="index" class="text-center"
						style="margin-top: 10px; background-color: #e7eef1;">
						<span>{{ item }}</span>
					</v-col>
				</v-row>

				<!-- Tabla de datos -->
				<v-row>
					<v-col class="pl-0 pt-0 pb-0 pr-0">
						<v-data-table :headers="headerProductionGroup" :items="summarytic" hide-default-footer
							disable-sort :loading="loadingData">
							<template v-slot:item.ProgramadaTo="{ item }">
								<v-chip small dark color="success">
									{{ item.ProgramadaTo }}
								</v-chip>
							</template>
							<template v-slot:item.NoProgramadaTo="{ item }">
								<v-chip small dark color="info">
									{{ item.NoProgramadaTo }}
								</v-chip>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-btn color="primary" @click="closeDialog">Cerrar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';

export default {
    name: 'TaskSummaryModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        areID: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            years: [],
            year: null,
            itemsWeek: [],
            week: [],
            BeginDate: null,
            EndDate: null,
            headerRow: ['', 'PROGRAMADO', 'NO PROGRAMADO'],
            headerProductionGroup: [
                { text: "Nombre", value: "WorkerName" },
                { text: "Total", value: "ProgramadaTo" },
                { text: "Pendiente", value: "ProgramadaPen" },
                { text: "Finalizado", value: "ProgramadaFin" },
                { text: "Total", value: "NoProgramadaTo", headerClass: 'success' },
                { text: "Pendiente", value: "NoProgramadaPen", headerClass: 'success' },
                { text: "Finalizado", value: "NoProgramadaFin", headerClass: 'success' }
            ],
            summarytic: [],
            Gensummarytic: [],
            loadingData: false
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                if (this.years.length === 0) {
                    for (let i = 1; i <= 53; i++) {
                        this.itemsWeek.push({ text: i, value: i });
                    }
                    this.years = this.$fun.getTop5LastYears();
                    this.year = this.$moment().year();
                    this.EndDate = this.$moment().add('days', -1).format("YYYY-MM-DD");
                    this.BeginDate = this.$moment().format("YYYY-MM-DD");
                }
                setTimeout(() => {
                    this.getTicSummary();
                    this.getTicGeneralSummary();
                }, 100);
            }
        },
        week() {
            this.updateDatesFromWeek();
        },
        BeginDate() {
            if (this.dialog) {
                this.getTicSummary();
                this.getTicGeneralSummary();
            }
        },
        EndDate() {
            if (this.dialog) {
                this.getTicSummary();
                this.getTicGeneralSummary();
            }
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
            this.week = [];
        },
        updateDatesFromWeek() {
            if (this.week == 1) {
                this.BeginDate = this.$moment(this.year + '0101').isoWeek(this.itemsWeek[0]).startOf("isoweek").format('YYYY-MM-DD');
                this.EndDate = this.$moment(this.year + '0101').isoWeek(this.itemsWeek[0]).endOf("isoweek").format('YYYY-MM-DD');

                if (this.year != this.$moment(this.year + '0101').isoWeek(this.itemsWeek[0]).startOf("isoweek").format('YYYY')) {
                    this.BeginDate = this.$moment(this.year + '0108').isoWeek(this.itemsWeek[0]).startOf("isoweek").format('YYYY-MM-DD');
                    this.EndDate = this.$moment(this.year + '0108').isoWeek(this.itemsWeek[0]).endOf("isoweek").format('YYYY-MM-DD');
                }
            } else if (this.week > 1) {
                if (this.itemsWeek[this.itemsWeek.length - 1].value > this.itemsWeek[0].value) {
                    let min = this.week;
                    this.BeginDate = this.$moment(this.year + '0101').isoWeek(min).startOf("isoweek").format('YYYY-MM-DD');
                    this.EndDate = this.$moment(this.year + '0101').isoWeek(min).endOf("isoweek").format('YYYY-MM-DD');
                } else {
                    let max = Math.max(...this.itemsWeek);
                    this.BeginDate = this.$moment(this.year + '0101').isoWeek(this.itemsWeek[this.itemsWeek.length - 1]).startOf("isoweek").format('YYYY-MM-DD');
                    this.EndDate = this.$moment(this.year + '0101').isoWeek(max).endOf("isoweek").format('YYYY-MM-DD');

                    if (this.year != this.BeginDate.year) {
                        this.BeginDate = this.$moment(this.year + '0108').isoWeek(this.itemsWeek[this.itemsWeek.length - 1]).startOf("isoweek").format('YYYY-MM-DD');
                        this.EndDate = this.$moment(this.year + '0108').isoWeek(max).endOf("isoweek").format('YYYY-MM-DD');
                    }
                }

                if (this.week.length > 1) {
                    if ((this.week.find((x) => { return x == (this.week[this.week.length - 1] - 1) }) == null) &&
                        (this.week.find((x) => { return x == (this.week[this.week.length - 1] + 1) }) == null)) {
                        this.week = this.week.filter((x) => { return x != this.week[this.week.length - 1] });
                    }
                }
            } else {
                this.EndDate = this.$moment().add('days', -1).format("YYYY-MM-DD");
                this.BeginDate = this.$moment().format("YYYY-MM-DD");
            }
            this.getTicSummary();
            this.getTicGeneralSummary();
        },
        getTicSummary() {
            this.loadingData = true;
            let obj = {
                AreID: this.areID,
                DateBegin: this.BeginDate,
                DateEnd: this.EndDate
            };
            _sTaskService.ticketSummary(obj, this.$fun.getUserID()).then(resp => {
                if (resp && resp.status == 200) {
                    this.summarytic = resp.data;
                }
                this.loadingData = false;
            });
        },
        getTicGeneralSummary() {
            let obj = {
                AreID: this.areID,
                DateBegin: this.BeginDate,
                DateEnd: this.EndDate
            };
            _sTaskService.ticketGeneralSummary(obj, this.$fun.getUserID()).then(resp => {
                if (resp && resp.status == 200) {
                    this.Gensummarytic = resp.data;
                }
            });
        },
        downloadExcel() {
            this.$fun.alert("¿Seguro de descargar?", "question").then(r => {
                if (r.value) {
                    _sTaskService.convertexcel(this.Gensummarytic, this.$fun.getUserID()).then(resp => {
                        this.$fun.downloadFile(resp.data, 2, this.$fun.getUserID());
                    });
                }
            });
        }
    }
};
</script>
